module.exports = __webpack_public_path__ + "img/bookshelf06.3ed5e9e6.jpg";